module.exports = __webpack_public_path__ + "img/strength-mobile.6af41449.png";